import {
  ACCOUNT_DASH,
    FETCH_DASHBOARD_DATA,
    TOGGLE_LOADING, 
    UNAUTHORIZED_DASHBOARD,  
    } from "../../constants/DashboardActionTypes";
  
  
    const initialState = {
      loading: false,
      unAuthorisedConversation:null,
      accountDash:null
    }
  
    const dashboardReducer = (state = initialState, { type, payload }) => {
      switch (type) {
        case TOGGLE_LOADING:
          return { ...state, loading: payload };
        case UNAUTHORIZED_DASHBOARD:
        return { ...state, unAuthorisedDashboard: payload };
        case FETCH_DASHBOARD_DATA:
        return { ...state, fetchDashboardData: payload };
        case ACCOUNT_DASH:
        return { ...state, accountDash: payload };
        default:
          return state;
      }
    };
  
    export default dashboardReducer;
  